import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
		// 老年版首页
		{
		    path: '/home',
		    component: resolve => require(['@/components/views/home.vue'], resolve),
		},
		// 实时公交
		{
		    path: '/busList',
		    component: resolve => require(['@/components/views/busList.vue'], resolve),
		},
		// 实时公交搜索
		{
		    path: '/search',
		    component: resolve => require(['@/components/views/search.vue'], resolve),
		},
        // 实时公交详情
        {
            path: '/routeDetail',
            component: resolve => require(['@/components/views/routeDetail.vue'], resolve),
        },
		// 线路规划
		{
		    path: '/routePlan',
		    component: resolve => require(['@/components/views/routePlan.vue'], resolve),
		},
		// 线路规划
		{
		    path: '/planDetail',
		    component: resolve => require(['@/components/views/planDetail.vue'], resolve),
		},
		// 车辆列表
		{
		    path: '/carList',
		    component: resolve => require(['@/components/views/carList.vue'], resolve),
		},
		// 新闻资讯
		{
		    path: '/newsList',
		    component: resolve => require(['@/components/views/newsList.vue'], resolve),
		},
		// 同站线路
		{
		    path: '/stopToRoute',
		    component: resolve => require(['@/components/views/stopToRoute.vue'], resolve),
		},
		// poi点搜索
		{
		    path: '/searchPoi',
		    component: resolve => require(['@/components/views/searchPoi.vue'], resolve),
		},
		// poi点搜索
		{
		    path: '/map',
		    component: resolve => require(['@/components/views/map.vue'], resolve),
		},
		// web
		{
		    path: '/webView',
		    component: resolve => require(['@/components/views/webView.vue'], resolve),
		},
		// 热点新闻
		{
		    path: '/hotNews',
		    component: resolve => require(['@/components/views/hotNews.vue'], resolve),
		},
		// 车来了实时
		{
		    path: '/cllBus',
		    component: resolve => require(['@/components/views/cllBus.vue'], resolve),
		},
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js